import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { proccessTaxonomyNames, processTaxonamyResponse } from './utils';

export const TAXONOMY = `${API_CONFIG.API}/taxonomy_term`;
export const TAXONOMY_NAMES_URL = `${API_CONFIG.API}/taxonomy_vocabulary/taxonomy_vocabulary`;

export default {
  discoverTaxonomies() {
    return base.http().get(`${TAXONOMY_NAMES_URL}`)
      .then(response => proccessTaxonomyNames(response));
  },
  getTaxonomy(vid) {
    return base.http().get(`${TAXONOMY}/${vid}`)
      .then(response => processTaxonamyResponse(response));
  },
};



// WEBPACK FOOTER //
// ./src/features/taxonomy/service.js